import { EXIST_LOCAL_STORAGE } from '../constants';
import { baseURL } from '../constants/app';
import { getExactPath, getStorage } from '../helperFunctions';

export const getIp = async () => fetch('https://ipapi.co/json/').then((response) => response.json());

export const makeSiteAnalytics = async (body: any) => {
    try {
        const response = await fetch(baseURL + '/SiteAnalytics/Analytics', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        });
        return await response.json();
    } catch (e) {
        console.log(e);
    }
};

export const makeNavigationSiteAnalytics = async (visitor_action: string, page_navigation: string, page_detail?: string) => {
    const currentPath = location.pathname;
    if (typeof window === 'undefined') return;

    const page_name = getExactPath(currentPath);
    const exactPageNavigation = getExactPath(page_navigation);

    const body = {
        site_visitor_id: getStorage(EXIST_LOCAL_STORAGE.SITE_VISITOR_ID),
        page_name,
        visitor_action,
        page_navigation: exactPageNavigation,
        page_detail,
    };

    const is_bounced = sessionStorage.getItem('is_bounced');
    if (is_bounced === 'true') {
        const bounced_body = {
            site_visitor_id: getStorage(EXIST_LOCAL_STORAGE.SITE_VISITOR_ID),
            is_bounced: false,
        };
        await makeSiteAnalytics(bounced_body);
        sessionStorage.setItem('is_bounced', 'false');
    }

    if (currentPath === page_navigation || currentPath.startsWith('/admin_panel') || page_navigation.startsWith('/admin_panel')) {
        console.log('Logging navigation analytics - canceled', body);
        return;
    }

    const response = await fetch(baseURL + '/SiteAnalytics/NavigationAnalytics', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    });
    console.log('Logging navigation analytics', body, response.ok);
    return await response.json();
};
